import useGetCrmSessionHook from "Hooks/CrmSessionHook";
import { CONSTANTS } from "consts";
import { Action, UserAppContext } from "contexts";
import { useContext, useEffect } from "react";
import {
    useCheckStravaConnectedMutation,
} from "services/crmServer";
import { getUrlVars } from "utils/url";
import {
    useHandleGetWorkoutList,
} from "../handleActions";

export const useMainHook = () => {
    const [checkStravaConnected] = useCheckStravaConnectedMutation();
    const { handleGetWorkoutList } = useHandleGetWorkoutList();

    const { WORKOUT_QUERY_RANGE, PROFILE_PAGE } = CONSTANTS;
    const {
        auth,
        workoutState,
        authDispatch,
        workoutDispatch,
        profileDispatch,
        timezone,
    } = useContext(UserAppContext);

    const { workoutMetrics, loading, currentSelect, workoutDetail } =
        workoutState;
    const appId = localStorage.getItem('appId');
    const isAvironTreadmill = appId === String(CONSTANTS.APP.AVIRON_TREADMILL);
    const formatWorkoutMetric = (workoutMetrics: any) => {
        if (isAvironTreadmill) {
            return {
                ...workoutMetrics,
                avgSPM: workoutMetrics.avgSecp500
            }
        }
        return workoutMetrics
    }
    const timeZone = timezone.timeZone;

    const params = getUrlVars();

    useEffect(() => {
        // For showing active tab
        profileDispatch(
            Action.profile.setState({
                current_tab: PROFILE_PAGE.CURRENT_TAB.PROFILE_WORKOUT,
            })
        );
        // get initial data
        // && auth.id
        if (auth) {
            handleGetWorkoutList(
                {
                    timeRange: WORKOUT_QUERY_RANGE.QUERY_RANGE_ALL,
                    page: Number(params.page) || 1,
                    userData: auth,
                    timeZone,
                },
                workoutDispatch
            );
        }
    }, [auth, timeZone]);


    const handleSelectTimeRange = (event: any) => {
        const timeRange = event.target.value;

        handleGetWorkoutList(
            { timeRange, page: 1, userData: auth, timeZone },
            workoutDispatch
        );
    };


    return {
        loading,
        currentSelect,
        workoutMetrics: formatWorkoutMetric(workoutMetrics),
        workoutDetail,
        handleSelectTimeRange,
    };
};
